import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import Tooltip from '@material-ui/core/Tooltip';
import KeyboardTabIcon from '@material-ui/icons/KeyboardTab';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import RepeatIcon from '@material-ui/icons/Repeat';
import { setDrawEvent, setDrawNestedTransaction, setDrawReuseTransaction, handleSnackBar, toggleRightDrawer, setFocusElement, setDrawTemplateTransaction } from '../../../store/global/actions';
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { invokeGetService } from "../../../store/global/actions";


const useStyles = makeStyles((theme) => ({
  backgroundStyle: {
    display: "flex",
    flexDirection: "row",
    position: "absolute",
    bottom: 0,
    right: 0,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    marginRight: 10,
  },

  root: {
    transform: 'translateZ(0px)',
    flexGrow: 1,
  },
  exampleWrapper: {
    position: 'relative',
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    zIndex: 999,
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
}));




export default function TransactionSpeedDial({ reset, disable }) {

  const dispatch = useDispatch();
  const classes = useStyles();
  // const transactions = useSelector(getAllTransactions);
  const [transactions, setTransactions] = React.useState([]);
  const [direction, setDirection] = React.useState('up');
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  useEffect(() => {
    dispatch(invokeGetService('getBlueprintConstructs', []))
      .then((response) => {
        if (response?.data !== undefined) {
          setTransactions(response.data.transactions)
        }
      })
  }, [])

  const handleClick = () => {
    reset();
    disable();
  }

  const actions = [
    // { icon: <SyncAltIcon onClick={handleClick} />, name: 'Create new transaction', type: 'transaction' },
    { icon: <KeyboardTabIcon onClick={handleClick} />, name: 'Draw an event', type: 'event' },
    { icon: <AssignmentReturnedIcon onClick={handleClick} />, name: 'Invoke transaction', type: 'reusedTransaction' },
    // { icon: <ExtensionIcon onClick={handleClick} />, name: 'Import template transaction', type: 'templateTransaction' },
    { icon: <RepeatIcon onClick={handleClick} />, name: 'Add child transaction', type: 'nestedTransaction' }
  ];

  const rightDrawerStatus = useSelector(getRightDrawerStatus);

  const handleHiddenChange = (event) => {
    setHidden(event.target.checked);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const onActionClick = (type) => {


    if (type == 'event') {

      dispatch(setDrawEvent(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing event between clusterlets', severity: 'info' }));

    } else if (type == 'transaction') {

      dispatch(setFocusElement({ id: null, type: 'transaction' }));
      if (rightDrawerStatus == false) {
        dispatch(toggleRightDrawer());
      }

    } else if (type == 'nestedTransaction') {

      dispatch(setDrawNestedTransaction(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing child transaction between clusterlets', severity: 'info' }));

    } else if (type == 'reusedTransaction') {

      dispatch(setDrawReuseTransaction(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing transaction to reuse between clusterlets', severity: 'info' }));

    } else if (type == 'templateTransaction') {
      dispatch(setDrawTemplateTransaction(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing transaction to reuse between clusterlets', severity: 'info' }));
    }
  }



  return (



    <div className={classes.backgroundStyle}>
      <div className={classes.root}>

        <div>

          <Tooltip title="Click to draw">
            <SpeedDial
              ariaLabel="Actions"
              className={classes.speedDial}
              hidden={hidden}
              icon={<SpeedDialIcon />}
              onClose={handleClose}
              onOpen={handleOpen}
              open={open}
              direction={direction}
            >
              {actions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  disabled={transactions.length <= 1 && action.type === 'reusedTransaction' ? true : false}
                  tooltipTitle={action.name}
                  onClick={e => { handleClose(); onActionClick(action.type) }}
                />
              ))}
            </SpeedDial>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}
